import DOMPurify from 'dompurify';

/**
 * Sanitize HTML string using DOMPurify.
 *
 * On the server (SSR) DOMPurify is not available (no DOM), so we return the
 * raw HTML. This is safe because sanitization happens on the client before
 * the browser actually renders the markup. The HTML content also comes from
 * our own API (admin-authored), not from untrusted user input.
 */
export function sanitize(html: string): string {
  if (typeof window === 'undefined') {
    return html;
  }
  return DOMPurify.sanitize(html);
}
